import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import { getPostResponseAPIData } from '../../services/apiService';
import { StyledCard } from './CustomTableStyle';
import Table from '../../components/reactTable/Table';
import SpinnerComponent from '../../components/SpinnerComponent/SpinnerComponent';
const TablePaginationComponent = withStyles({
  select: {
    border: '1px solid #ADADAD',
    borderRadius: '2px'
  }
})(TablePagination);

const MuiVirtualizedTable = props => {
  const {
    columns
  } = props;
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const dispatch = useDispatch();
  const relationUrl = useSelector(state => state.customQueryHeader.relationUrl);
  const requestBody = useSelector(state => state.customQueryHeader.relRequestBody);
  const apiResponseData = useSelector(state => state.customQueryHeader.relationTableData);
  const [tableData, setTableData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('ENVIRONMENT');
  const [continuePagination, setcontinuePagination] = useState(false);

  const handleChangePage = (event, newPage) => {
    setTableData([]);
    setcontinuePagination(true);
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setTableData([]);
    setPageNumber(0);
    setcontinuePagination(true);
    setRowsPerPage(parseInt(event.target.value));
  };

  useEffect(() => {
    if (apiResponseData && apiResponseData.data) {
      setTableData(apiResponseData.data);
      setTotalCount(apiResponseData.totalCount);
    }
  }, [apiResponseData]);
  useEffect(() => {
    if (continuePagination) {
      let urlArray = [];
      let paginationQueryString = `limit=${rowsPerPage}&offset=${pageNumber + 1}
        &sortBy=${orderBy}&orderType=${order}`;
      urlArray.push(relationUrl + paginationQueryString);
      dispatch(getPostResponseAPIData(urlArray, requestBody, 'run'));
    }
  }, [rowsPerPage, pageNumber]);

  const handleSortBy = sortColumn => {
    const isDsc = orderBy === sortColumn.id && order === 'desc';
    let sortOrder = isDsc === true ? 'asc' : 'desc';
    setOrder(isDsc ? 'asc' : 'desc');
    setOrderBy(sortColumn.id);
    let urlArray = [];
    let paginationQueryString = `&limit=${rowsPerPage}&offset=${pageNumber + 1}&sortBy=${sortColumn.id}&orderType=${sortOrder}`;
    urlArray.push(relationUrl + paginationQueryString);
    setTableData([]);
    dispatch(getPostResponseAPIData(urlArray, requestBody, 'run'));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, tableData && tableData.length > 0 ? /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: tableData,
    handleSort: handleSortBy,
    order: order,
    sortOrderBy: orderBy
  }), /*#__PURE__*/React.createElement(TablePaginationComponent, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: totalCount,
    page: pageNumber,
    labelDisplayedRows: ({
      page,
      count
    }) => `Page ${page + 1} of  ${Math.ceil(count / rowsPerPage) != 0 ? Math.ceil(count / rowsPerPage) : 1}`,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }))) : /*#__PURE__*/React.createElement(SpinnerComponent, null));
};

const CustomTable = props => {
  let {
    columns = [],
    results = {}
  } = props;
  let {
    data,
    totalCount,
    totalPages
  } = results;
  let visibleCols = columns.filter(col => !!col.hidden === false);
  return /*#__PURE__*/React.createElement(MuiVirtualizedTable, {
    columns: visibleCols,
    data: data,
    totalCount: totalCount,
    totalPages: totalPages
  });
};

export default CustomTable;